import DropdownSelect from './DropdownSelect';

function HoursDropdownSelect(props) {

    const timeHoursOptions = [
        { name: '0 Hours', value: 0 },
        { name: '1 Hour', value: 0 },
        ...([...Array(props.max-1).keys()].map(number => {return { name: `${number+2} Hours`, value: number+2 }}))
    ]

    return <DropdownSelect className={props.className} options={timeHoursOptions} value={props.value} onChange={props.onChange} placeholder='Hours' disabled={props.disabled} />
}

export default HoursDropdownSelect;